import React, { useEffect, useState, useMemo, useRef, Children } from "react";
import SelectInput from "./../../components/common/ui/Inputs/SelectInput";
import { DateInput, TextInput } from "../../components/common/ui/Inputs";
import Button from "../../components/common/ui/Button";
import ExcelExport from "../../components/common/ui/Export/ExcelExport";
import Table from "../../components/common/table/Table";
import { useDispatch, useSelector } from "react-redux";
import { masterActions, reportingAction } from "../../_store";
import generateXlsx from "../../components/common/export/generateXlsx";
import { useLocation } from "react-router-dom";
import CustomLoader from "../../components/common/ui/Loader";
import RedIcon from "../../assets/KioRed.png";
import GreenIcon from "../../assets/KioGreen.png";
import OrangeIcon from "../../assets/KioOrange.png";
import ClosedIcon from "../../assets/padlock_flat_style.jpg";
import OpenIcon from "../../assets/5c23f889-065f-43dd-a012-0e87b13e47b8.jpg";
import CommonModal from "../../components/common/ui/NotificationModal/CommonModal";
import FacilityAdminMenuAccess from "./../ManagementUser/FacilityAdminMenuAccess";
import { showToastNotification } from "../../components/common/ui/NotificationModal/ToastNotication";
import {
  fDate,
  getCurrentDate,
  getPastDate,
  MinDate,
  Today,
} from "../../utils/formatTime";
const STATUS_ACTIVE = 1;
const DEFAULT_GENDER_ID = 0;
const DEFAULT_ACTIVE_STATUS = 1; // Active status default
const DEFAULT_PAGE_NO = 1; // Default page number as a string
const DEFAULT_ROW_COUNT_PER_PAGE = 10; // Default row count per page as a string

function ManageUserActivity() {
  const dispatch = useDispatch();
  // Destructuring dropdownOptions from the state in a single useSelector call
  const {
    logHistoryLastName: logHistoryLastName,
    logHistorFirstName: logHistorFirstName,
  } = useSelector((state) => state.master);
  const { commonFacilityCode: facilityCode } = useSelector(
    (state) => state.auth
  );
  const user = useSelector((x) => x.auth.user);
  const [showSearchFields, setShowSearchFields] = useState(false);
  const reduxFormAccessDetailListByID = useSelector(
    (x) => x?.reporting?.LoadManagementRequestActiveFormPermission
  );
  const reduxRepliedFormCountDetailsByID = useSelector(
    (x) => x?.reporting?.LoadManagementUserPermissionFormReportList
  );

  const reduxManagmentUserName = useSelector(
    (state) => state.reporting?.getRequestFormPermissionManagementUser
  );
  const reduxManagmentFormtitle = useSelector(
    (state) => state.reporting?.getManagementUserRequestFormPermission
  );
  const FormReportListloading = useSelector(
    (state) => state.reporting?.FormReportListloading
  );
  const repliedFormcountloading = useSelector(
    (state) =>
      state.reporting?.LoadManagementUserPermissionFormReportList?.loading
  );
  const formAccessloading = useSelector(
    (x) => x?.reporting?.LoadManagementRequestActiveFormPermission?.loading
  );
  const reduxMangmentUserList = useSelector(
    (state) => state.reporting?.LoadManagementUserFormReportList
  );
  const isPageReloading = useSelector((state) => state.master?.isPageReload);

  const reduxMangmentUserFullList = useSelector(
    (state) => state.reporting?.LoadManagementUserFormReportFullList
  );
  const shouldShowExcelExport = reduxMangmentUserList?.DataList?.length > 0;
  const statusOptions = [
    { value: 2, label: "Both" },
    { value: 1, label: "Request Opened" },
    { value: 0, label: "Request Closed" },
  ];

  const [formAccess, setFacilityPCR] = useState({
    mangementUserID: user?.ManagementUserID,
    PageNo: 1,
    RowCountPerPage: 10,
  });
  const [repliedForm, setRepliedForm] = useState({
    PageNo: 1,
    RowCountPerPage: 10,
    responseManagementUserID: 0,
  });

  const initialuserActivityData = useSelector(
    (state) => state.reporting?.userActivityDataSearch
  );

  useEffect(() => {
    const params = {
      ...initialuserActivityData,
      facilityID: facilityCode,
      managementUserID: user?.ManagementUserID,
    };
    dispatch(reportingAction?.setuserActivityDataSearch(params));
  }, [facilityCode]);

  // Function to handle form submission
  const handleManagmentUserSearchSubmit = (e) => {
    e.preventDefault(); // Prevent default form submission behavior
    const updateFacilityID = {
      ...initialuserActivityData,
      managementUserID: user?.ManagementUserID,
      facilityID: facilityCode,
    };
    dispatch(
      reportingAction.setuserActivityDataSearch({
        ...updateFacilityID,
        pageNo: 1,
        rowCountPerPage: 10,
      })
    );
    dispatch(
      reportingAction.LoadManagementUserFormReportList({
        ...updateFacilityID,
        pageNo: 1,
        rowCountPerPage: 10,
      })
    ); // Dispatch the action to load POD list
  };

  useEffect(() => {
    const loadFacilities = async () => {
      try {
        await dispatch(
          masterActions.LoadFacilityDropDown({
            facilityID: 0,
            ActiveStatus: DEFAULT_ACTIVE_STATUS,
          })
        );
      } catch (error) {
        console.error("Error loading facilities:", error);
      }
    };
    loadFacilities();
  }, []);

  useEffect(() => {
    dispatch(
      reportingAction.LoadManagementUserFormReportList({
        ...initialuserActivityData,
        facilityID: facilityCode,
        managementUserID: user?.ManagementUserID,
      })
    );
  }, [
    isPageReloading,
    initialuserActivityData?.rowCountPerPage,
    initialuserActivityData?.pageNo,
    facilityCode,
  ]);

  useEffect(() => {
    dispatch(
      masterActions.GetInmateFirstName({
        facilityID: facilityCode,
        LastName: "",
      })
    );
    dispatch(
      masterActions.GetInmateLastName({
        facilityID: facilityCode,
        FirstName: "",
      })
    );
    dispatch(
      reportingAction.GetRequestFormPermissionManagementUser(facilityCode)
    );
    dispatch(
      reportingAction.GetManagementUserRequestFormPermission(facilityCode)
    );
  }, [facilityCode]);

  useEffect(() => {
    dispatch(
      reportingAction.LoadManagementRequestActiveFormPermission(formAccess)
    );
  }, [formAccess?.PageNo, formAccess?.RowCountPerPage]);
  useEffect(() => {
    const params = {
      FacilityID: facilityCode,
      RequestFormTypeID: initialuserActivityData?.requestFormTypeID,
      reqCurrentStatus: initialuserActivityData?.reqCurrentStatus,
      RequestCreateStartDate_Show:
        initialuserActivityData?.RequestCreateStartDate_Show,
      RequestCreateEndDate_Show:
        initialuserActivityData?.RequestCreateEndDate_Show,
      RequestCreateStartDate: initialuserActivityData?.requestCreateStartDate,
      RequestCreateEndDate: initialuserActivityData?.requestCreateEndDate,
      InmateFirstNames: initialuserActivityData?.inmateFirstNames,
      InmateLastNames: initialuserActivityData?.inmateLastNames,
      InmateId: initialuserActivityData?.inmateId,
      managementUserID: initialuserActivityData?.managementUserID,
      responseManagementUserID: repliedForm?.responseManagementUserID,
      PageNo: repliedForm?.PageNo,
      RowCountPerPage: repliedForm?.RowCountPerPage,
      SortBy: "",
    };
    dispatch(
      reportingAction.LoadManagementUserPermissionFormReportList(params)
    );
  }, [repliedForm?.PageNo, repliedForm?.RowCountPerPage]);

  const location = useLocation(); // Get the location object
  const { state } = location; // Destructure state from location

  const handlePCRRowPerPage = (page) => {
    setFacilityPCR((prevState) => ({
      ...prevState,
      RowCountPerPage: page,
    }));
  };

  const handlePCRPageChange = (page) => {
    setFacilityPCR((prevState) => ({
      ...prevState,
      PageNo: page,
    }));
  };

  const handleRepliedFormRowPerPage = (value) => {
    setRepliedForm((prevState) => ({
      ...prevState,
      RowCountPerPage: value,
    }));
  };

  const handleRepliedFormPageChange = (page) => {
    setRepliedForm((prevState) => ({
      ...prevState,
      PageNo: page,
    }));
  };

  let sorting = false;
  const handleSort = (column, sortDirection) => {
    if (!column?.key) return;
    sorting = true;
    const search = { ...initialuserActivityData };
    const newSortOrder = search.SortBy?.includes(column.key)
      ? search.SortBy.endsWith("asc")
        ? "desc"
        : "asc"
      : "asc";
    search.SortBy = `${column.key} ${newSortOrder}`;
    dispatch(reportingAction?.setuserActivityDataSearch(search));
    // setFacilityPCR(search);

    dispatch(
      reportingAction.LoadManagementUserFormReportList({
        ...initialuserActivityData,
        facilityID: facilityCode,
        SortBy: `${column.key} ${newSortOrder}`,
      })
    );
  };

  const handleFormAccessCount = (row) => {
    if (row?.AccessFormCount === 0) {
      showToastNotification("No Forms in replied status", "error");
      return;
    }
    setFacilityPCR((prev) => ({
      ...prev,
      mangementUserID: row.MangementUserID,
      PageNo: 1,
      RowCountPerPage: 10,
    }));
    dispatch(
      reportingAction.LoadManagementRequestActiveFormPermission({
        ...formAccess,
        mangementUserID: row.MangementUserID,
      })
    );
  };
  const handleRepliedCount = (row) => {
    setRepliedForm((prev) => ({
      ...prev,
      PageNo: 1,
      RowCountPerPage: 10,
    }));

    if (row?.RequestFormCount === 0) {
      showToastNotification("No Forms in replied status", "error");
      return;
    }
    // const updateFacilityID = {
    //   ...initialuserActivityData,
    //   PageNo: 1,
    //   ResponseManagementUserID: row.MangementUserID,
    // };
    setRepliedForm((prev) => ({
      ...prev,
      responseManagementUserID: row?.MangementUserID,
    }));
    const params = {
      FacilityID: facilityCode ?? "",
      RequestFormTypeID: initialuserActivityData?.requestFormTypeID ?? "",
      reqCurrentStatus: initialuserActivityData?.reqCurrentStatus ?? "",
      RequestCreateStartDate_Show:
        initialuserActivityData?.RequestCreateStartDate_Show ?? "",
      RequestCreateEndDate_Show:
        initialuserActivityData?.RequestCreateEndDate_Show ?? "",
      RequestCreateStartDate:
        initialuserActivityData?.requestCreateStartDate ?? "",
      RequestCreateEndDate: initialuserActivityData?.requestCreateEndDate ?? "",
      InmateFirstNames: initialuserActivityData?.InmateFirstNames ?? "",
      InmateLastNames: initialuserActivityData?.InmateLastNames ?? "",
      InmateId: initialuserActivityData?.InmateId ?? "",
      ManagementUserID: initialuserActivityData?.managementUserID ?? "",
      responseManagementUserID: row.MangementUserID ?? "",
      PageNo: 1,
      RowCountPerPage: 10,
      SortBy: "",
    };
    dispatch(
      reportingAction.LoadManagementUserPermissionFormReportList(params)
    );
  };

  const columns = [
    {
      name: "Username",
      selector: (row) => row.UserName,
      sortable: true,
      key: "UserName",
    },
    {
      name: "Form Access Permission Count",
      selector: (row) => row.AccessFormCount,
      sortable: true,
      key: "AccessFormCount",
      cell: (row) => (
        <div
          className="Common_Link_Style"
          {...(row?.AccessFormCount !== 0 && {
            "data-bs-toggle": "modal",
            "data-bs-target": "#userActivity_formAccessPermission_Modal",
          })}
          onClick={() => handleFormAccessCount(row)}
        >
          {row.AccessFormCount}
        </div>
      ),
    },
    {
      name: "Replied Form Count",
      selector: (row) => row.RequestFormCount,
      sortable: true,
      key: "RequestFormCount",
      cell: (row) => (
        <div
          className="Common_Link_Style"
          {...(row?.RequestFormCount !== 0 && {
            "data-bs-toggle": "modal",
            "data-bs-target": "#userActivity_RequestCount_Modal",
          })}
          onClick={() => handleRepliedCount(row)}
        >
          {row.RequestFormCount}
        </div>
      ),
    },
    {
      name: "Last Login Date Time",
      selector: (row) => row.LastLoginDateTime,
      key: "LastLoginDateTime",
      sortable: true,
    },
    {
      name: "Status",
      selector: (row) => row.LoginStatus,
      key: "LoginStatus",
      cell: (row) => (
        <div>
          <div
            className={`in-icon-size ${row.LastLoginDateTime === "-" && row.RequestFormCount === 0
                ? "user-batch button-success"
                : row.LastLoginDateTime !== "-" && row.RequestFormCount === 0
                  ? "user-batch orange-icon"
                  : row.LastLoginDateTime !== "-" && row.RequestFormCount !== 0
                    ? "user-batch button-primary"
                    : ""
              }`}
          >
            {row.LastLoginDateTime === "-" && row.RequestFormCount === 0 ? (
              <>
                <div className="user-batch button-primary"></div>
              </>
            ) : row.LastLoginDateTime !== "-" && row.RequestFormCount === 0 ? (
              <div className="user-batch button-orange"></div>
            ) : row.LastLoginDateTime !== "-" && row.RequestFormCount !== 0 ? (
              <div className="user-batch button-success"></div>
            ) : null}
          </div>
        </div>
      ),
      //sortable: true,
    },
  ];

  const formAccessPermissionChildColumn = [
    {
      name: "Request Form Type",
      selector: (row) => row.RequestFormTitle,
      //sortable: true,
    },
    {
      name: "Accessible Form Status",
      selector: (row) =>
        row.RepliedFormPermissionStatus === 0 ? "Disabled" : "Enabled",

      //sortable: true,
    },
  ];

  const repliedFormCountColumn = [
    {
      name: "Request Form Type",
      selector: (row) => row.RequestFormTitle,
    },
    {
      name: "Inmate ID",
      selector: (row) => row.InmateResidentId,
    },
    {
      name: "Inmate Full Name",
      selector: (row) => row.InmateName,
    },
    {
      name: "Replied Count",
      selector: (row) => row.AssignedRepliedCount,
    },
    {
      name: "Created Date",
      selector: (row) => row.CreateDateTime,
    },
    {
      name: "Last Replied Date",
      selector: (row) => row.LastReplayDate,
    },
    {
      name: "Accessible Form Status",
      selector: (row) =>
        row.RepliedFormPermissionStatus === 0 ? "Disabled" : "Enabled",
    },
    {
      name: "Form Status",
      selector: (row) => row.FromStatus,
      cell: (row) => (

        row.FromStatus !== 0 ? (
          <span
            style={{ marginleft: "10px" }}
            title="Open"
            className="status-open"
          >
            Open
          </span>
        ) : (
          <span
            style={{ marginleft: "10px" }}
            title="Closed"
            className="status-Closed"
          >
            Closed
          </span>
        )
      )
    },
  ];

  // Access the passed id from state
  const podID = state?.id; // Use optional chaining to avoid errors if state is undefined

  //The function effectively updates the state based on input changes.
  const updateFormField = (e) => {
    // Ensure e.target is defined to prevent destructuring errors
    const { target } = e || {};

    if (!target) return; // Exit if target is not available

    const { name, value } = target;

    // Update state using setinitialuserActivityData with previous state

    const params = { ...initialuserActivityData, [name]: value };
    dispatch(reportingAction.setuserActivityDataSearch(params));
  };
  const updatedData = { ...initialuserActivityData };

  const handleDateChange = (name, value) => {
    const date = fDate(value);
    const newData = { ...updatedData, [name]: date };

    dispatch(reportingAction.setuserActivityDataSearch(newData));
  };
  const handleDateEnterKey = (event, name) => {
    if (event.key === "Enter" && updatedData[name] === "") {
      const currentDate = new Date();

      // Set today's date using the same logic as your handleDateChange
      handleDateChange(name, currentDate);
    }

    const regex = /^[0-9/]$/; // Allow numbers and "/"

    if (
      !regex.test(event.key) &&
      event.key !== "Backspace" &&
      event.key !== "Delete" &&
      !(event.ctrlKey && event.key === "v")
    ) {
      event.preventDefault();
    }

    // Auto-insert '/' when typing
    const input = event.target.value;

    if (event.key !== "Backspace" && event.key !== "Delete") {
      if (input?.length === 2 || input?.length === 5) {
        event.target.value = input + "/";
      }
    }
  };

  const handleDateBlur = (e, fieldName) => {
    let { value } = e.target;
    let isFromValid = true;
    let isToValid = true;
    const updatedData = { ...initialuserActivityData };
    if (fieldName === "requestCreateStartDate") {
      if (
        updatedData.requestCreateEndDate &&
        new Date(value) > new Date(updatedData.requestCreateEndDate)
      ) {
        // Invalid: FromDate cannot be after ToDate
        isFromValid = false;
      }
    } else if (fieldName === "requestCreateEndDate") {
      if (
        updatedData.requestCreateStartDate &&
        new Date(value) < new Date(updatedData.requestCreateStartDate)
      ) {
        // Invalid: ToDate cannot be before FromDate
        isToValid = false;
      }
    }

    // Define date format used
    const minDate = MinDate();
    const today = Today();
    const valueDate = new Date(value);
    const isValidDate = valueDate >= minDate && valueDate <= today;

    let updatedParam = {
      ...updatedData,
      requestCreateStartDate:
        fieldName === "requestCreateStartDate"
          ? isFromValid && isValidDate
            ? value
            : ""
          : updatedData.requestCreateStartDate, // preserve existing value
      requestCreateEndDate:
        fieldName === "requestCreateEndDate"
          ? isToValid && isValidDate
            ? value
            : ""
          : updatedData.requestCreateEndDate, // preserve existing value
    };

    dispatch(reportingAction.setuserActivityDataSearch(updatedParam));
  };

  // Function to handle dropdown changes for different fields
  const updateSelectedOption = (selectedOption, name) => {
    // Create a shallow copy of the initial log history data
    const paramsCopy = { ...initialuserActivityData, pageNo: DEFAULT_PAGE_NO, rowCountPerPage: DEFAULT_ROW_COUNT_PER_PAGE, 
};

    // Helper function to update state and params
    const updatePODData = (value) => {
      const updatedValue = value != null ? value : ""; // Allow empty values
      const updatedData = { ...initialuserActivityData, pageNo: DEFAULT_PAGE_NO, rowCountPerPage: DEFAULT_ROW_COUNT_PER_PAGE };

      updatedData[name] = updatedValue;
      paramsCopy[name] = updatedValue;

      dispatch(reportingAction.setuserActivityDataSearch(updatedData));
    };

    // Handle specific cases based on field name
    switch (name) {
      case "responseManagementUserID":
        updatePODData(parseInt(selectedOption?.value || 0, 10));
        break;

      case "requestFormTypeID":
        updatePODData(parseInt(selectedOption?.value || 0, 10));
        break;
      case "reqCurrentStatus":
        updatePODData(selectedOption ? parseInt(selectedOption.value, 10) : 2);
        break;
      default:
        updatePODData(selectedOption?.label || "");
        break;
    }

    // Add FacilityID and PodID to the params copy
    const updateFacilityID = {
      ...paramsCopy,

      FacilityID: facilityCode,
    };

    // Dispatch the action for log history if not dealing with FromDate or ToDate
    if (!["RequestCreateStartDate", "RequestCreateEndDate"].includes(name)) {
      dispatch(
        reportingAction.LoadManagementUserFormReportList(updateFacilityID)
      );
    }
  };

  const resetUserActivity = () => {
    // Default values for reset
    const DEFAULT_RESET_STATE = {
      facilityID: facilityCode,
      requestFormTypeID: 0,
      reqCurrentStatus: 2,
      requestCreateStartDate: getPastDate(6),
      requestCreateEndDate: getCurrentDate(),
      inmateFirstNames: "",
      inmateLastNames: "",
      inmateFirstNameId: 0,
      inmateLastNameId: 0,
      inmateId: "",
      managementUserID: user?.ManagementUserID,
      responseManagementUserID: 0,
      pageNo: 1,
      rowCountPerPage: 10,
      sortBy: "",
    };
    dispatch(reportingAction.setuserActivityDataSearch(DEFAULT_RESET_STATE));
    // Early return if facilityCode is not available
    if (!facilityCode) return;
    // Dispatch actions to reset names and load log history
    dispatch(
      masterActions.GetInmateLastName({
        facilityID: facilityCode,
        FirstName: "",
      })
    );
    dispatch(
      masterActions.GetInmateFirstName({
        facilityID: facilityCode,
        LastName: "",
      })
    );
    dispatch(
      reportingAction.LoadManagementUserFormReportList(DEFAULT_RESET_STATE)
    );
  };

  // const updateLastandFirstName = (selectedOption, name) => {
  //   const paramsCopy = { ...initialuserActivityData };
  //   // const isLastName = name === "InmateLastNames";

  //   const clearData = () => {
  //     paramsCopy[name] = "";
  //     if (isLastName) paramsCopy.InmateFirstNames = "";
  //     else paramsCopy.InmateLastNames = "";
  //     dispatch(reportingAction.setuserActivityDataSearch(paramsCopy));
  //     dispatch(
  //       masterActions.GetInmateFirstName({
  //         facilityID: facilityCode,
  //         LastName: "",
  //       })
  //     );
  //     dispatch(
  //       masterActions.GetInmateLastName({
  //         facilityID: facilityCode,
  //         FirstName: "",
  //       })
  //     );
  //   };

  //   const updateData = () => {
  //     paramsCopy[name] = selectedOption.value;
  //     dispatch(reportingAction.setuserActivityDataSearch(paramsCopy));

  //     if (isLastName) {
  //       dispatch(
  //         masterActions.GetInmateFirstName({
  //           facilityID: facilityCode,
  //           LastName: selectedOption.label,
  //         })
  //       );
  //     } else {
  //       dispatch(
  //         masterActions.GetInmateLastName({
  //           facilityID: facilityCode,
  //           FirstName: selectedOption.label,
  //         })
  //       );
  //     }
  //   };

  //   if (selectedOption === null || selectedOption?.value === 0) {
  //     clearData();
  //   } else {
  //     updateData();
  //   }

  //   const updatedFacilityID = { ...paramsCopy, FacilityID: facilityCode };
  //   dispatch(
  //     reportingAction.LoadManagementUserFormReportList(updatedFacilityID)
  //   );
  // };

  const handleSelectChange = (selectedOption, name) => {
    const updatedSearch = { ...initialuserActivityData };

    const loadList = () => {
      updatedSearch.pageNo = 1;
      updatedSearch.rowCountPerPage = 10;
      updatedSearch.facilityID = facilityCode;

      dispatch(reportingAction.LoadManagementUserFormReportList(updatedSearch));
    };

    const handleFirstName = () => {
      updatedSearch[name] =
        selectedOption?.value > 0 ? selectedOption?.label : "";
      updatedSearch.inmateFirstNameId = selectedOption?.value || 0;
      dispatch(
        masterActions.GetInmateLastName({
          facilityID: facilityCode,
          FirstName: "",
        })
      );
      loadList();
    };

    const handleLastName = () => {
      updatedSearch[name] =
        selectedOption?.value > 0 ? selectedOption?.label : "";
      updatedSearch.inmateLastNameId = selectedOption?.value || 0;

      updatedSearch.inmateFirstNames = "";
      updatedSearch.inmateFirstNameId = 0;

      dispatch(
        masterActions.GetInmateFirstName({
          facilityID: facilityCode,
          LastName: updatedSearch?.inmateLastNames,
        })
      );

      loadList();
    };

    switch (name) {
      case "inmateLastNames":
        handleLastName();
        break;

      case "inmateFirstNames":
        handleFirstName();
        break;

      default:
        break;
    }
    dispatch(reportingAction.setuserActivityDataSearch(updatedSearch));
  };

  const generateExcelReport = () => {
    // Define the title of the Excel sheet
    const title = "ManagementUserReport";

    // Define the column headers for Excel
    const generateExcelColumns = [
      "Username",
      "Form Access Permission Count",
      "Replied Form Count",
      "Last Login Date Time",
      "Status",
    ];

    const updateTotalRows = {
      ...initialuserActivityData,
      rowCountPerPage: reduxMangmentUserList?.TotalRecordCount,
      exportExcel: true,
      pageNo: 1,
      //FacilityID: facilityCode,
    };

    // Dispatch and process the response
    dispatch(reportingAction?.LoadManagementUserFormReportList(updateTotalRows))
      .then((response) => {
        // Ensure logHistoryFullData and DataList are valid
        const { DataList = [] } = response.payload || {}; // Assuming response contains DataList directly
        // Map the data for Excel
        const docList = DataList.map((obj) => ({
          Username: obj.UserName,
          AccessFormCount: obj.AccessFormCount,
          RequestFormCount: obj.RequestFormCount,
          LastLoginDateTime: obj.LastLoginDateTime,
          Status:
            obj.LastLoginDateTime === "-" && obj.RequestFormCount === 0
              ? "Not Login and Not Replied"
              : obj.LastLoginDateTime !== "-" && obj.RequestFormCount === 0
                ? "Login and Not Replied"
                : obj.LastLoginDateTime !== "-" && obj.RequestFormCount !== 0
                  ? "Login and Replied"
                  : "",
        }));

        // Check if there is data before generating the Excel
        //if (docList.length === 0) return
        generateXlsx(docList, generateExcelColumns, title);
      })
      .catch((error) => {
        // Handle errors gracefully
        console.error("Error loading Inmate Login Log History:", error);
      });
  };

  const handleRowPerPage = (page) => {
    const params = {
      ...initialuserActivityData,
      rowCountPerPage: page,
      pageNo: 1,
    };
    dispatch(reportingAction.setuserActivityDataSearch(params));
  };

  const handlePageChange = (page) => {
    if (sorting) {
      sorting = false;
      return;
    }
    const params = { ...initialuserActivityData, pageNo: page };
    dispatch(reportingAction.setuserActivityDataSearch(params));
  };
  const handleResetPageandRowCount = () => {
    setFacilityPCR((prevState) => ({
      ...prevState,
      RowCountPerPage: 10,
      pageNo: 1,
    }));
    setRepliedForm((prevState) => ({
      ...prevState,
      RowCountPerPage: 10,
      pageNo: 1,
    }));
  };

  if (FormReportListloading) {
    return <CustomLoader />;
  }

  const toggleInformation = () => {
    setShowSearchFields((prev) => !prev);
  };
  const renderSearch = () => {
    return (
      <form onSubmit={handleManagmentUserSearchSubmit}>
        <div className="row">
          <div className="col-sm-6 col-md-6 col-lg-4">
            <div className="form-floating mb-3">
              <SelectInput
                options={reduxManagmentUserName}
                value={initialuserActivityData?.responseManagementUserID}
                handleChange={(selectedOption) =>
                  updateSelectedOption(
                    selectedOption,
                    "responseManagementUserID"
                  )
                }
                isMulti={false}
                closeMenuOnSelect={true}
                isDisabled={false}
                isLoading={false}
                isClearable={initialuserActivityData?.responseManagementUserID}
                //placeholder="--ALL--"
                label="Username"
              />
            </div>
          </div>
          <div className="col-sm-6 col-md-6 col-lg-4">
            <div className="form-floating mb-3">
              <SelectInput
                options={reduxManagmentFormtitle}
                value={initialuserActivityData?.requestFormTypeID}
                handleChange={(selectedOption) =>
                  updateSelectedOption(selectedOption, "requestFormTypeID")
                }
                isMulti={false}
                closeMenuOnSelect={true}
                isDisabled={false}
                isLoading={false}
                isClearable={initialuserActivityData?.requestFormTypeID}
                placeholder="--ALL--"
                label="Form Title"
              />
            </div>
          </div>
          <div className="col-sm-6 col-md-6 col-lg-4">
            <div className="form-floating mb-3">
              <TextInput
                name="InmateId"
                id="InmateId"
                label="Inmate ID"
                value={initialuserActivityData.InmateId}
                handleChange={updateFormField}
                placeholder="Inmate ID"
                required={false}
                maxLength={20}
              ></TextInput>
            </div>
          </div>
          <div className="col-sm-6 col-md-6 col-lg-4">
            <div className="form-floating mb-3">
              <SelectInput
                options={logHistoryLastName}
                value={initialuserActivityData.inmateLastNameId}
                handleChange={(selectedOption) =>
                  handleSelectChange(selectedOption, "inmateLastNames")
                }
                isMulti={false}
                closeMenuOnSelect={true}
                isDisabled={false}
                isLoading={false}
                isClearable={initialuserActivityData.inmateLastNameId !== 0}
                //placeholder="--ALL--"
                label="Inmate Last Name"
              />
            </div>
          </div>
          <div className="col-sm-6 col-md-6 col-lg-4">
            <div className="form-floating mb-3">
              <SelectInput
                options={logHistorFirstName}
                value={initialuserActivityData.inmateFirstNameId}
                handleChange={(selectedOption) =>
                  handleSelectChange(selectedOption, "inmateFirstNames")
                }
                isMulti={false}
                closeMenuOnSelect={true}
                isDisabled={false}
                isLoading={false}
                isClearable={initialuserActivityData.inmateFirstNameId !== 0}
                placeholder="--ALL--"
                label="Inmate First Name"
              />
            </div>
          </div>
          <div className="col-sm-6 col-md-6 col-lg-4">
            <div className="form-floating mb-3">
              <DateInput
                value={initialuserActivityData.requestCreateStartDate} // Ensure proper date object
                handleChange={(date) =>
                  handleDateChange("requestCreateStartDate", date)
                }
                name="FromDate"
                label={"Created Start Date"}
                minDate={new Date(2017, 0, 1)}
                maxDate={
                  initialuserActivityData.requestCreateEndDate
                    ? initialuserActivityData.requestCreateEndDate
                    : getCurrentDate()
                }
                required={false}
                disabled={false}
                yearDropDown={true}
                monthDropDown={true}
                isClearable={initialuserActivityData.requestCreateStartDate}
                handleBlur={(e) => handleDateBlur(e, "requestCreateStartDate")}
                handleKeyDown={(e) =>
                  handleDateEnterKey(e, "requestCreateStartDate")
                }
              />
            </div>
          </div>
          <div className="col-sm-6 col-md-6 col-lg-4">
            <div className="form-floating mb-3">
              <DateInput
                value={initialuserActivityData.requestCreateEndDate} // Ensure proper date object
                name="ToDate"
                handleChange={(date) =>
                  handleDateChange("requestCreateEndDate", date)
                }
                minDate={
                  initialuserActivityData.requestCreateStartDate
                    ? initialuserActivityData.requestCreateStartDate
                    : new Date(2017, 0, 1)
                } // Restrict min date to FromDate
                maxDate={getCurrentDate()}
                label={"Created End Date"}
                required={false}
                disabled={false}
                yearDropDown={true}
                monthDropDown={true}
                isClearable={initialuserActivityData?.requestCreateEndDate}
                handleBlur={(e) => handleDateBlur(e, "requestCreateEndDate")}
                handleKeyDown={(e) =>
                  handleDateEnterKey(e, "requestCreateEndDate")
                }
              />
            </div>
          </div>
          <div className="col-sm-6 col-md-6 col-lg-4">
            <div className="form-floating mb-3">
              {/* Status */}

              <SelectInput
                options={statusOptions}
                value={initialuserActivityData.reqCurrentStatus}
                handleChange={(selectedOption) =>
                  updateSelectedOption(selectedOption, "reqCurrentStatus")
                }
                isMulti={false}
                closeMenuOnSelect={true}
                isDisabled={false}
                isLoading={false}
                isClearable={initialuserActivityData.reqCurrentStatus !== 2}
                placeholder="--ALL--"
                label="Form Status"
              />
            </div>
          </div>
        </div>

        {/* Buttons */}
        <div className="mt-3 d-flex flex-wrap justify-content-center gap-3">
          <Button
            variant="primary"
            className="me-2"
            label={"SEARCH"}
            type={"submit"}
            status={"primary"}
            disabled={false}
            icon={"search"}
          ></Button>
          <Button
            variant="secondary"
            className="me-2"
            onClick={resetUserActivity}
            label={"RESET"}
            type={"button"}
            icon={"fa-solid fa-rotate-right"}
            status={"secondary"}
            disabled={false}
          />
        </div>
      </form>
    );
  };

  return (
    <div>
      <div className="d-flex flex-wrap flex-column justify-content-center align-items-center position-relative">
        <div className="card b-r-all  p-4 border border-dark-grey mt-3 me-3 w-100">
          {/* <div className="row align-items-center">
            <div className="col-lg-11 col-md-9 col-sm-10 col-8 mb-2">
              {facilityCode !== 0 ? (
                <h3 className="form_title_uppercase text-color">
                  Management User Form
                </h3>
              ) : (
                ""
              )}
            </div>
          </div> */}
          <div className=" d-block d-md-none">
            <div
              className=" d-flex align-items-center justify-content-between"
              style={{ background: "transparent", cursor: "pointer" }}
              onClick={toggleInformation}
            >
              {facilityCode !== 0 ? (
                <h2 className="form_title_uppercase text-color">
                  Management User Form
                </h2>
              ) : (
                ""
              )}
              <i
                id="itagInformation"
                className={`fa fa-angle-down ${showSearchFields ? "rotate" : ""
                  }`}
                style={{ fontSize: "20px" }}
              ></i>
            </div>
          </div>
          {/* Mobile only (Below md breakpoint) */}
          <div className="d-block d-md-none mt-2">
            {showSearchFields && renderSearch()}
          </div>

          {/* Web only (Desktop and above) */}
          <div className="mb-3 d-none d-md-block">
            <h2 className="form_title_uppercase text-color">
              Management User Form
            </h2>
          </div>
          {/* Web only (Desktop and above) */}
          <div className="d-none d-md-block">{renderSearch()}</div>
        </div>

        <>
          <div className="mt-3 w-100">
            <div className="d-flex flex-wrap justify-content-between mb-2 align-items-center resp-space">
              <h2 className="form_title_uppercase text-color">Management User Activities List</h2>

              <div className="d-flex flex-wrap gap-3 align-items-center">
                {shouldShowExcelExport && (
                  <ExcelExport
                    variant="soft-gray"
                    handleExcelExport={generateExcelReport}
                  />
                )}
              </div>
            </div>
            {reduxMangmentUserList?.DataList?.length > 0 && (
              <div className="d-flex flex-wrap align-items-center gap-3">
                <div className="d-flex flex-wrap align-items-center">
                  <div className="user-batch button-success m-2"></div>
                  <span>Login and Replied</span>
                </div>

                <div className="d-flex flex-wrap align-items-center">
                  <div className="user-batch button-orange m-2"></div>
                  <span>Login and Not Replied</span>
                </div>

                <div className="d-flex flex-wrap align-items-center">
                  <div className="user-batch button-primary m-2"></div>
                  <span>Not Login and Not Replied</span>
                </div>
              </div>
            )}
            <Table
              columns={columns}
              data={reduxMangmentUserList?.DataList}
              pagination
              onChangeRowsPerPage={handleRowPerPage}
              onChangePage={handlePageChange}
              totalRowCount={reduxMangmentUserList?.TotalRecordCount}
              currentPage={initialuserActivityData?.pageNo}
              paginationPerPage={initialuserActivityData.rowCountPerPage}
              onSort={handleSort}
              serverSideSort
              sortColumn={initialuserActivityData?.SortBy?.split(" ")[0]}
              sortDirection={initialuserActivityData?.SortBy?.split(" ")[1]}
            />
          </div>
          <div>
            {/* {formAccessCount && ( */}
            <CommonModal
              modalId="userActivity_RequestCount_Modal"
              title="Replied Form Details"
              loader={repliedFormcountloading}
              handleCloseIcon={handleResetPageandRowCount}
              bodyContent={
                <>
                  <h4>
                    Management Username:{" "}
                    {reduxRepliedFormCountDetailsByID?.DataList?.[0]
                      ?.ManagementUser || ""}
                  </h4>
                  <Table
                    key={repliedForm.RowCountPerPage}
                    columns={repliedFormCountColumn}
                    data={reduxRepliedFormCountDetailsByID?.DataList}
                    pagination
                    totalRowCount={
                      reduxRepliedFormCountDetailsByID?.TotalRecordCount
                    }
                    onChangeRowsPerPage={handleRepliedFormRowPerPage}
                    onChangePage={handleRepliedFormPageChange}
                    currentPage={repliedForm?.PageNo}
                    paginationPerPage={repliedForm.RowCountPerPage}
                  />
                </>
              }
              footerContent={
                <button
                  className="btn button-primary"
                  onClick={() => {
                    handleResetPageandRowCount();
                  }}
                  data-bs-dismiss="modal"
                >
                  Close
                </button>
              }
            />
            {/* )} */}
          </div>
          {/* {repliedFormCount && ( */}
          <CommonModal
            modalId="userActivity_formAccessPermission_Modal"
            title="Accessible Form Details"
            loader={formAccessloading}
            handleCloseIcon={handleResetPageandRowCount} //for cross icons
            bodyContent={
              <>
                <Table
                  key={formAccess.RowCountPerPage}
                  columns={formAccessPermissionChildColumn}
                  data={reduxFormAccessDetailListByID?.DataList}
                  pagination
                  totalRowCount={
                    reduxFormAccessDetailListByID?.TotalRecordCount
                  }
                  onChangeRowsPerPage={handlePCRRowPerPage}
                  onChangePage={handlePCRPageChange}
                  currentPage={formAccess?.PageNo}
                  paginationPerPage={formAccess.RowCountPerPage}
                />
              </>
            }
            footerContent={
              <button
                className="btn button-primary"
                data-bs-dismiss="modal"
                onClick={() => {
                  handleResetPageandRowCount();
                }}
              >
                Close
              </button>
            }
          />
          {/* )} */}
        </>
      </div>
    </div>
  );
}

export default React.memo(ManageUserActivity);
